import { render, staticRenderFns } from "./nxScrollPane.vue?vue&type=template&id=e88794e8&scoped=true"
import script from "./nxScrollPane.vue?vue&type=script&lang=js"
export * from "./nxScrollPane.vue?vue&type=script&lang=js"
import style0 from "./nxScrollPane.vue?vue&type=style&index=0&id=e88794e8&prod&rel=stylesheet%2Fless&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e88794e8",
  null
  
)

export default component.exports